import { Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { getAuthTrigger, useGetAuthReason } from "@outschool/ui-auth";
import { Container } from "@outschool/ui-legacy-component-library";
import React from "react";
import { useLocation } from "react-router-dom";

import * as Routes from "../../shared/Routes";
import HeaderTags from "../components/HeaderTags";
import SimpleLayout from "../components/layouts/SimpleLayout";
import LoginForm from "../components/LoginForm";
import { useAppState } from "../stores/AppStateProvider";

export default function Login() {
  const { t } = useTranslation("client\\routes\\Login");
  const { postLoginAction, postLoginPath } = useAppState();
  const authTrigger = getAuthTrigger(postLoginAction, postLoginPath);
  const getAuthReason = useGetAuthReason();
  const authReason = getAuthReason(authTrigger);
  const location = useLocation();

  const link = [{ rel: "canonical", href: Routes.loginUrl() }];

  const metaTags = [
    {
      name: "description",
      content: t`Login to access your learning schedule, transcript, favorite classes, reviews, profile settings and more.`
    },
    {
      property: "og:title",
      content: t`Login To Outschool`
    }
  ];

  if (location && location.query?.hasOwnProperty("postLoginPath")) {
    metaTags.push({ name: "robots", content: "noindex" });
  }

  return (
    <SimpleLayout>
      <HeaderTags title={t`Log In`} meta={metaTags} link={link} />
      <Container
        size="tiny"
        sx={{
          display: "grid",
          gap: "medium",
          justifyItems: "center",
          marginY: "large",
          maxWidth: "400px"
        }}
      >
        <Typography variant="h2">{t`Log In`}</Typography>
        {/* TODO Figure out how to localize this */}
        {/* eslint-disable-next-line i18next/no-literal-string */}
        {authReason && "Log in to " + authReason}
        <LoginForm />
      </Container>
    </SimpleLayout>
  );
}
